import { messagePostEphemeralDescription as description } from './description';
import { postEphemeral as execute } from './execute';

export { description, execute };
